// extracted by mini-css-extract-plugin
export default {"hidden":"App_hidden__PlKoC","appWrapper":"App_appWrapper__0fnnQ"};